export function setNotifications(state, notifications) {
   notifications.forEach(function(notification){
    if (!state.notifications.some(n => n.id === notification.id)) {
      state.notifications.push(notification)
    } 
  })
}

export function setNotification(state, notification) {
  state.notifications.unshift(notification)
}

export function setTotalUnseenNotifications(state, totalUnseenNotifications) {
  state.totalUnseenNotifications = totalUnseenNotifications;
}
export function addTotalUnseenNotifications(state) {
  state.totalUnseenNotifications += 1;
}

export function updateNotification(state, payload){
  const notification = state.notifications.forEach(notification => {
    if(notification.id === payload){
      notification.seen_at = true
      state.totalUnseenNotifications -= 1 
    }
  })
}

export function notificationsError(state, payload) {
  state.error = true;
  state.errorMessage = payload;
  state.posts = [];
}
